export enum HSBTipoRicercaRisorsaUmanaEnum {
	GenericheNominative = 0,
	Generiche = 1,
	Nominative = 2,
}
